<!-- <div *ngIf="paymenttrueorfalls" class="payment-status-container">
  <h2>Payment Details</h2>
  <table class="payment-details-table">
    <tr>
      <td><strong>First Name:</strong></td>
      <td>{{ paymentDetails.first_name }}</td>
    </tr>
    <tr>
      <td><strong>Email:</strong></td>
      <td>{{ paymentDetails.email }}</td>
    </tr>
    <tr>
      <td><strong>Mobile:</strong></td>
      <td>{{ paymentDetails.mobile }}</td>
    </tr>
    <tr>
      <td><strong>Transaction ID:</strong></td>
      <td>{{ paymentDetails.txnid }}</td>
    </tr>
    <tr>
      <td><strong>Plan Name:</strong></td>
      <td>{{ paymentDetails.plan_name }}</td>
    </tr>
    <tr>
      <td><strong>Amount:</strong></td>
      <td>{{ paymentDetails.amount }}</td>
    </tr>
    <tr>
      <td><strong>Service Provider:</strong></td>
      <td>{{ paymentDetails.service_provider }}</td>
    </tr>
  </table>

  <div class="status-message">
    <h1>{{ status }}</h1>
  </div>
 -->
<!-- </div> -->
<div class="main_container" style="overflow: hidden;">
  <div class="row payment_successful" *ngIf="paymentStatus ==='successful'">
    <div class="col-md-5">
      <div class="message-box successful_details">
        <div><img src="/assets/payment_sucessful.png" style="height:250px;width:250px;margin-bottom: 20px;"></div>
        <div class="payment_header"> Your Payment was Successful </div>
        <div class="payment_description">
          Thank you for your payment. We will be in contact with more details shortly.
        </div>
      </div>
      <div class="disclaimer">Please do not click anything. You will be automatically redirected to the main page in a
        few seconds.</div>
    </div>
  </div>
  <div class="row payment_failed" *ngIf="paymentStatus === 'failed'">
    <div class="col-md-5">
      <div class="message-box Failed_payment">
        <div><img src="/assets/payment_decline.png" style="height:210px;width:260px;margin-bottom: 20px;"></div>
        <div class="payment_header"> Your Payment Failed </div>
        <div class="payment_description">
          Please check your personal, card info, and connection, and try again.
        </div>
      </div>
      <div class="disclaimer">Please do not click anything. You will be automatically redirected to the main page in a
        few seconds.</div>
    </div>
  </div>
  <div class="row payment_cancelled" *ngIf="paymentStatus === 'cancelled'">
    <div class="col-md-5">
      <div class="message-box cancelled_payment">
        <div><img src="/assets/payment_cancelled.png" style="height:210px;width:260px;margin-bottom: 20px;"></div>
        <div class="payment_header"> Your Payment Was Cancelled </div>
        <div class="payment_description">
          The payment has been cancelled successfully. If you have any questions or need further assistance, please
          contact support.
        </div>
      </div>
      <div class="disclaimer">Please do not click anything. You will be automatically redirected to the main page in a
        few seconds.</div>
    </div>
  </div>
  <div class="download-receipt">
    <a (click)="downloadReceipt()" href="javascript:void(0);">
      <span class="material-icons">download</span> Download Receipt
    </a>
  </div>
</div>
